import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import kuTranslations from './locales/ku.json';
import arTranslations from './locales/ar.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            ku: { translation: kuTranslations },
            en: { translation: enTranslations },
            ar: { translation: arTranslations }
        },
        lng: localStorage.getItem('i18nextLng') || 'ku',
        fallbackLng: 'ku',
        interpolation: { escapeValue: false }
    });

export default i18n;

i18n.on('languageChanged', (lng) => {
    localStorage.setItem('i18nextLng', lng);
});